export enum EDevice {
  WEB = 'WEB',
  MOBILE = 'MOBILE'
}

export const DEVICES = Object.values(EDevice);
